import { render } from "./CDashboard.vue?vue&type=template&id=08dca69a"
import script from "./CDashboard.vue?vue&type=script&lang=js"
export * from "./CDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__